import Vue from 'vue'
import Vuex from 'vuex'
import wxb from '@/store/wxb'
import auth from '@/store/auth'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    path:''
  },
  mutations: {
    add(state,pay){
       state.map=pay
    },
    const(state,pay){
      state.path=pay
    }
  },
  actions: {
  },
  modules: {
    'wxb': wxb,
    'auth': auth,
  },
})